import * as React from "react";
import "./PrismicLogo.scss"; // We'll create this CSS file

const SVGComponent = (props) => {
    const parts = [
        { id: "part1", className: "logo-part part-1" },
        { id: "part2", className: "logo-part part-2" },
        { id: "part3", className: "logo-part part-3" },
        { id: "part4", className: "logo-part part-4" },
        { id: "part5", className: "logo-part part-5" },
        { id: "part6", className: "logo-part part-6" },
        { id: "part7", className: "logo-part part-7" },
        { id: "part8", className: "logo-part part-8" },
    ];

    return (
        <svg
            viewBox="0 0 28 28"
            fill="none"
            width="40px"
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 xl:h-7 w-auto prismic-logo"
            title="Prismic Logotype"
        >
            {/* Top Right Section - Part 1 */}
            <path
                id={parts[0].id}
                className={parts[0].className}
                fillRule="evenodd"
                clipRule="evenodd"
                d="m27.629 14.573-2.064-2.06a.869.869 0 0 1-.256-.616V9.376c0-2.33-.242-3.175-.699-4.026a4.753 4.753 0 0 0-1.98-1.976c-.853-.455-1.7-.698-4.033-.698h-3.339a.175.175 0 0 1-.123-.297l2.063-2.06a.877.877 0 0 1 .62-.256h1.16c3.112 0 4.24.323 5.378.93a6.337 6.337 0 0 1 2.64 2.635c.608 1.135.932 2.262.932 5.368v5.454a.175.175 0 0 1-.3.123Z"
            />

            {/* Bottom Right Section - Part 2 */}
            <path
                id={parts[1].id}
                className={parts[1].className}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.389 27.64l2.064-2.06a.876.876 0 0 1 .62-.256h2.524c2.334 0 3.18-.243 4.034-.698a4.754 4.754 0 0 0 1.979-1.976c.456-.851.7-1.696.7-4.026v-3.332a.174.174 0 0 1 .298-.123l2.064 2.06a.87.87 0 0 1 .255.616v1.159c0 3.106-.323 4.233-.932 5.368a6.338 6.338 0 0 1-2.64 2.634c-1.137.608-2.266.931-5.378.931h-5.464a.174.174 0 0 1-.124-.297Z"
            />

            {/* Bottom Left Section - Part 3 */}
            <path
                id={parts[2].id}
                className={parts[2].className}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.363 15.487l-2.064-2.06A.175.175 0 0 0 0 13.55v5.454c0 3.106.324 4.232.933 5.368a6.337 6.337 0 0 0 2.639 2.634c1.138.608 2.266.931 5.378.931h1.16a.877.877 0 0 0 .62-.256l2.063-2.06a.174.174 0 0 0-.124-.297H9.331c-2.334 0-3.18-.243-4.034-.698a4.753 4.753 0 0 1-1.98-1.976c-.456-.852-.699-1.696-.699-4.026v-2.522a.869.869 0 0 0-.255-.615Z"
            />

            {/* Top Left Section - Part 4 */}
            <path
                id={parts[3].id}
                className={parts[3].className}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.539.36l-2.064 2.06a.876.876 0 0 1-.62.256H9.332c-2.334 0-3.18.243-4.034.698a4.753 4.753 0 0 0-1.98 1.976c-.456.851-.699 1.696-.699 4.026v3.332a.175.175 0 0 1-.299.123L.256 10.77A.87.87 0 0 1 0 10.155V8.996C0 5.89.324 4.763.933 3.628A6.338 6.338 0 0 1 3.572.994C4.71.386 5.838.063 8.95.063h5.465a.175.175 0 0 1 .124.297Z"
            />



            {/* Left Center Section - Part 6 */}

        </svg>
    );
};

export default SVGComponent;